import styled from 'styled-components'

const Score = styled.p`
  padding: 5px 20px;
  font-size: 16px;
  font-weight: 500;
  background-color: #eee;
  border-radius: 5px;
`

export default Score



// WEBPACK FOOTER //
// ./src/UI/Score/Score.js